/*****************************  Intelligems  as low as on collection starts    *****************************/
window.loadIntelligemsPrices = function() {
    if ($("body").hasClass("customer-logged-in")) {
// if (true) {
    
    $("product-card").each(function () {
        
        let id = $(this).attr("data-v-id"); // safer
        
        if (!id) return;

let discount =window?.igData?.price?.getDiscountByVariantId?.(`${id}`) ?? 0;
        let price = window?.igData?.price?.getPriceByVariantId?.(id) ?? 0;
    let finalPrice = price - (discount || 0);
    
    // console.log("Variant:", id);
    // console.log("Price:", price);
    // console.log("Discount:", discount);
    // console.log("Final:", finalPrice);
    
    if (price>0) {
        $(this).find(".price").text(`$${price}`);
    }
     $(this).find(".price_wrapper_jtpl .price").css("visibility", "visible");
     
    });
}
else{

    var campaigns_data = igData.campaigns.getAll();
    for(var zz=0; zz<campaigns_data.length; zz++){
     var name = campaigns_data[zz].name;
       var camp_desc = campaigns_data[zz].description;
        camp_desc = camp_desc.replace('"','');
        camp_desc = camp_desc.replace("'",'');
        var tiers_length = campaigns_data[zz].discount.tiers.length;
        var discountType = campaigns_data[zz].discount.discountType;
        var ret = parseInt(tiers_length) - 1 ;
        var max_price = campaigns_data[zz].discount.tiers[ret].maximumUnits;
        var minUnit = campaigns_data[zz].discount.tiers[ret].minimumUnits;
    
        
        // console.log("camp_desc---",camp_desc);
        // console.log("Sku---",name);
        // console.log("discountType---",discountType);
        // console.log("campaign--",campaigns_data[zz]);
        
        
        if(discountType == "percentage"){
            // console.log("Percent----");
            
          if($("product-card[data-sku='"+name+"']").length > 0){
          var unitDiscount =  parseFloat($("product-card[data-sku='"+name+"']").attr("data-price")) * parseFloat(campaigns_data[zz].discount.tiers[ret].unitDiscount)/100 ;
          // console.log("iii--",unitDiscount);
          
          }
           if($("product-card[data-description='"+camp_desc+"']").length > 0){
             var unitDiscount =  parseFloat($("product-card[data-description='"+camp_desc+"']").attr("data-price")) * parseFloat(campaigns_data[zz].discount.tiers[ret].unitDiscount)/100 ;
          }
        }else{
          var unitDiscount = campaigns_data[zz].discount.tiers[ret].unitDiscount;
        
        }
        if($("product-card[data-sku='"+name+"']").length > 0){
         var discounted_price = parseFloat($("product-card[data-sku='"+name+"']").attr("data-price")) - parseFloat(unitDiscount);
        $("product-card[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl span").text("$"+ discounted_price.toFixed(2) + " /each");
        $("product-card[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl").css("display","block");
        $("product-card[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl").addClass("price-added")
        $("product-card[data-sku='"+name+"']").find(".intelligems-as-low-as-price-jtpl").parent(".price-wrapper-inline").find(".price--main, .product-type, div[ref='priceContainer']").css("display","none");
        continue;
    }
    if($("product-card[data-description='"+camp_desc+"']").length > 0){
        var discounted_price = parseFloat($("product-card[data-description='"+camp_desc+"']").attr("data-price")) - parseFloat(unitDiscount);
        $("product-card[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl span").text("$"+ discounted_price.toFixed(2) + " /each");
        $("product-card[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl").css("display","block");
        $("product-card[data-description='"+camp_desc+"']").find(".intelligems-as-low-as-price-jtpl").addClass("price-added")
        $("product-card[data-description='" + camp_desc + "']").find(".intelligems-as-low-as-price-jtpl").parent(".price-wrapper-inline").find(".price--main, .product-type , div[ref='priceContainer']").css("display", "none");
             continue;
        }
    }
    $("product-card").find(".intelligems-as-low-as-price-jtpl:not(.price-added)").parent().find(".price").css("visibility", "visible");
}
}
  /*****************************  Intelligems  as low as on collection ends    *****************************/

window.addEventListener('ig:ready', () => {
    console.log("Intellifems ready----");
    loadIntelligemsPrices();
    // setTimeout(()=>{window.history.pushState(null, '', window.location.pathname);},2000)
});
$(document).on("filter:update",function () {
    setTimeout(() => {
        loadIntelligemsPrices();
        window.reInitStarRatings();
            console.log("filter:update---")
        }, 2000);    
});



  // Code for changing intelligems price on product page starts
window.addEventListener('ig:ready', () => {
 
  let v_id=$("[id^=ProductInformation] form input[name=id]").val()
  if (v_id) {
    $('[id^="ProductInformation"] .price_wrapper_jtpl .price').not('quick-add-dialog .price').css("opacity", "1")
    getVariantDiscount(v_id);
    if ($("body").hasClass("not-logged-in")) {
      updatePriceBanner()
      console.log("updatePriceBanner-----");
      
    }
  }

});

   
    $(document).on("variant:update",function (e) {
    console.log("vvv",e.originalEvent.detail.resource.id)
    console.log("ee",e);
    
    let v_id = e.originalEvent.detail.resource.id;
    getVariantDiscount(`${v_id}`);
     
    })

window.getVariantDiscount= function(v_id) {
  let discount = Number(window.igData.price.getDiscountByVariantId(v_id));
    let price = Number(window.igData.price.getPriceByVariantId(v_id));
    
    let finalPrice = price - (discount || 0);
    
    // console.log("Variant:", v_id);
    // console.log("Price:", price);
    // console.log("Discount:", discount);
    // console.log("Final:", finalPrice);
    let total = (discount/100)+price 
    let dis_percent = parseInt(((discount/100)/total)*100)
    
    if (price > 0 && discount > 0) {
      $(".product-details .price_wrapper_jtpl .price").text(`$${price}`);
      $(".customer-quantity-box .quantity-wholesale-price").text(`$${(discount/100).toFixed(2)}`)
      $(".quantity-retail-price").text(`$${total.toFixed(2)}`)
      $(".customer-quantity-box .quantity-percentage-discount").text(`${dis_percent}%`)
      $(".igtg-price-container").show();
      if ($(".tagged-customer-banner-intelligems-price-jtpl").length) {
        $(".tagged-customer-banner-intelligems-price-jtpl").remove();
      }
      $(".igtg-price-container").append(`<span style="display:none;" class="tagged-customer-banner-intelligems-price-jtpl">${price}</span>`);
      // console.log("Disp----",dis_percent);
      // if ($(".quick-add-modal[open]")) {
      //   $(".quick-add-modal[open]").find(".product-details .price_wrapper_jtpl .price").text(`$${price}`);
      // $(".quick-add-modal[open]").find(".customer-quantity-box .quantity-wholesale-price").text(`$${(discount/100).toFixed(2)}`)
      // $(".quick-add-modal[open]").find(".quantity-retail-price").text(`$${total.toFixed(2)}`)
      // $(".quick-add-modal[open]").find(".customer-quantity-box .quantity-percentage-discount").text(`${dis_percent}%`)
      // $(".quick-add-modal[open]").find(".igtg-price-container").show();
      // }
    }
    $('[id^="ProductInformation"] .price_wrapper_jtpl .price').not('quick-add-dialog .price').css("opacity", "1")
}

function updatePriceBanner() {
  var campaigns_data = igData.campaigns.getAll();

  for(var zz=0; zz<campaigns_data.length; zz++){
    var name = campaigns_data[zz].name;
   var camp_desc = campaigns_data[zz].description;
    camp_desc = camp_desc.replace('"','');
    camp_desc = camp_desc.replace("'",'');
    var tiers_length = campaigns_data[zz].discount.tiers.length;
    var discountType = campaigns_data[zz].discount.discountType;
    var ret = parseInt(tiers_length) - 1 ;
    var max_price = campaigns_data[zz].discount.tiers[ret].maximumUnits;
    var minUnit = campaigns_data[zz].discount.tiers[ret].minimumUnits;

  var name_text = $("input[name='sku']").val().toUpperCase();
  if ($(".quick-add-modal[open]").length) {
    name_text = $(".quick-add-modal[open] input[name='sku']").val().toUpperCase();
  }
     var name_upr = name.trim().toUpperCase();
     var description_text = $(".product-details h1").text().trim().toUpperCase();
     var description_upr = camp_desc.toUpperCase();
if($(".multi-tier-wrapper").length > 0 && (name_upr == name_text ||  description_upr.replace('"','') == description_text.replace('"','').replace('"',''))){
       var product_html_1 = '<div class="multi-tier-items">Order More</div>';
       var product_html_2 = '<div class="multi-tier-items">Save More!</div>';

    // console.log("name_upr---",name_upr)
    //  console.log("name_text---",name_text)
       var tiers_data = campaigns_data[zz].discount.tiers;
        for(var xx=0; xx< tiers_data.length ; xx++){
          var max_price_2 = tiers_data[xx].maximumUnits;
          var minUnit_2 = tiers_data[xx].minimumUnits;
          //  console.log(tiers_data[xx]);
            var max_price_2 = $(".price_wrapper_jtpl .price").text();
            if($(".quick-add-modal[open]").length){
                max_price_2 = $(".quick-add-modal[open] .price_wrapper_jtpl .price").text();
            }
            // console.log("max_price_2"+ max_price_2);
          var main_price_2 = max_price_2.replace("$","");
          var product_type = $(".product-details .product-type").text();
          if(product_type.indexOf("each") > -1){
            var pro_type_data = "each";
          }else{
            var pro_type_data = "pack";
          }
         if(discountType == "percentage"){
           var unitDiscount_2 = parseFloat(main_price_2) * tiers_data[xx].unitDiscount/100;
          }else{
          var unitDiscount_2 = tiers_data[xx].unitDiscount;
          }
          var disc_price = parseFloat(main_price_2) - parseFloat(unitDiscount_2);
          if(discountType == "percentage"){
           var persentDiscount_2 = tiers_data[xx].unitDiscount
          }else{
          var persentDiscount_2 = 100 - (disc_price / parseFloat(main_price_2)*100);
          }
          product_html_1+= '<div class="multi-tier-items"><span id="intelligems-quantity-jtpl-'+xx+'" class="intelligems-quantity-jtpl" data-index="'+xx+'" data-qty="'+minUnit_2+'">'+minUnit_2+'</span>+<span> '+pro_type_data+'</span></div>';
          product_html_2+= '<div class="multi-tier-items"><span id="intelligems-discounted-price-jtpl-'+xx+'" class="intelligems-discounted-price-jtpl" data-index="'+xx+'" data-tier-price='+disc_price.toFixed(2)+'>$'+disc_price.toFixed(2)+'</span><span>/'+pro_type_data+'</span><span class="precentage_offer"><span id="intelligems-precentage-price-jtpl-'+xx+'" class="intelligems-precentage-price-jtpl">'+Math.round(persentDiscount_2)+'%</span> off</span></div>';
        }
      $(".multi-tier-wrapper .multi-tier-body:first-child .multi-tier-items-jtpl").html(product_html_1);
      $(".multi-tier-wrapper .multi-tier-body:last-child .multi-tier-items-jtpl").html(product_html_2);
      $(".popup-notification.product.multi-tier-breaks").attr("style","display:block !important");
    break;
      }else{
        $(".popup-notification.product.multi-tier-breaks").parents(".shopify-block").hide();
      }
} 
}



// Code for changing intelligems price on product page ends